import './Comparator.sass'

import * as React from 'react'
import MultiSizeImg from '../MultiSizeImg/MultiSizeImg'
import { ComparatorProps, ComparatorStateProps } from './'
import { debounce } from 'debounce'
import { delay } from '../../utils/helpers'

export default class Comparator extends React.Component<ComparatorProps, ComparatorStateProps> {
  static defaultProps = {
    dividerClass: 'comparator-divider',
    className: '',
    reactOnClick: true,
    darkened: false,
    active: true,
    demonstration: false,
    dividerTouched: false
  }

  private wrapperRef: React.RefObject<HTMLDivElement>
  private dividerRef: React.RefObject<HTMLDivElement>
  public frameId: any

  private updateInitialValues: () => any

  state = {
    separatorPositionX: 0,
    wrapperWidth: 0,
    activeOnMobile: true,
    rightBreakPoint: 0,
    leftBreakPoint: 0,
    rightBreakPointReached: false,
    leftBreakPointReached: false,
    dividerTouched: false,
    animationActive: false
  }
  
  constructor(props: ComparatorProps) {
    super(props)

    this.wrapperRef = React.createRef()
    this.dividerRef = React.createRef()
    
    this.handleClick = this.handleClick.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.setInitialValues = this.setInitialValues.bind(this)
    this.moveDivider = this.moveDivider.bind(this)

    this.updateInitialValues = debounce(this.setInitialValues, 500)
  }


  componentDidMount() {
    this.setInitialValues()

    if (this.props.demonstration) {
      const delayTime = 1000

      delay(this.moveDivider, delayTime)
    }

    window.addEventListener('resize', this.updateInitialValues)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateInitialValues)
  }

  setInitialValues(): void {
    const wrapper = this.wrapperRef
    const wrapperWidth = wrapper.current!.offsetWidth
    const wrapperMidWidth = wrapperWidth / 2
    const separatorPositionX = this.props.demonstration ? wrapperWidth : wrapperMidWidth
    const rightBreakPoint =  wrapperMidWidth + 200

    this.setState({
      wrapperWidth,
      separatorPositionX: separatorPositionX,
      rightBreakPoint
    })
  }

  handleClick(e: React.MouseEvent): void {
    this.setState({ 
      dividerTouched: true,
      separatorPositionX: e.clientX - this.getWrapperLeftOffset()
    })
  }

  handleMouseMove(e: React.MouseEvent): void {
    if (this.props.reactOnClick) {
      if (e.buttons) {
        this.setState({ separatorPositionX: e.clientX - this.getWrapperLeftOffset() })
      }
    } else {
      this.setState({ separatorPositionX: e.clientX - this.getWrapperLeftOffset() })
    }
  }

  handleTouchMove(e: React.TouchEvent): void {
    const separatorPositionX = e.touches[0].pageX - this.getWrapperLeftOffset()
  
    if (separatorPositionX > 0) {
      this.setState({ 
        separatorPositionX,
        dividerTouched: true
      })
    }
  }

  getWrapperLeftOffset(): number {
    return this.wrapperRef.current!.offsetLeft
  }

  moveDivider() {
    const { wrapperWidth } = this.state
    const leftBreakPoint = (wrapperWidth / 2) + 160

    this.setState({ 
      animationActive: true,
      separatorPositionX: leftBreakPoint
    })
  }

  render() {
    const {
      beforeImage,
      afterImage,
      dividerClass,
      beforeLabel,
      afterLabel,
      className,
      afterImageClass,
      beforeImageClass,
      content,
      darkened,
      demonstration,
      onImageLoaded
    } = this.props

    const {
      separatorPositionX,
      wrapperWidth,
      dividerTouched,
      animationActive
    } = this.state

    const containerStyles = {
      width: '100%'
    }

    const beforeStyles = {
      width: `${separatorPositionX}px`
    }
  
    const separatorStyles = {
      left: separatorPositionX
    }

    const renderContentLayer = content ?
      <div className='main-content'>
        {content}
      </div> :
      null

    const animatedClass = animationActive && demonstration && !dividerTouched ? 'animated' : ''
    const isDarkened = darkened ? 'darkened' : ''

    const beforeLayer = <div className={`comparator-content before ${animatedClass} ${beforeImageClass}`} style={beforeStyles}>
      <div className={`comparator-overlay-wrapper ${isDarkened}`} style={{ width: wrapperWidth }}>
        <div className='comparator-overlay'>
        {beforeLabel ? beforeLabel: null}
        </div>
      </div>
      <div className='image-wrapper'>
        <MultiSizeImg source={beforeImage} onImageLoaded={onImageLoaded} />
      </div>
    </div>

    const afterLayer = <div className={`comparator-content after ${afterImageClass}`}>
      <div className={`comparator-overlay-wrapper ${isDarkened}`} style={{ width: wrapperWidth }}>
        <div className='comparator-overlay'>
          {afterLabel ? afterLabel: null}
        </div>
      </div>
      <div className='image-wrapper'>
        <MultiSizeImg
          source={afterImage}
        />
      </div>
    </div>
    
    return (
      <div
        className={`comparator ${className}`}
        onClick={this.handleClick}
        onMouseMove={this.handleMouseMove}
        onTouchMove={this.handleTouchMove}
        style={containerStyles}
        ref={this.wrapperRef}
      >

        <div className={`${dividerClass} ${animatedClass}`} style={separatorStyles} ref={this.dividerRef} />

        { beforeLayer }

        { afterLayer }

        { renderContentLayer }

      </div>
    )
  }
}